var render = function render(){var _vm=this,_c=_vm._self._c;return _c('activity-modal',{attrs:{"activity":_vm.activity,"icon":_vm.icon,"header":_vm.$t('station.activityLog.modal.updateSummary')},on:{"close":function($event){return _vm.$emit('close')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }